__webpack_require__.p = "https://dev.labtracker.nterprise.com/";